import type { FetchResponse } from '../api/ReplicantAPI';

export class ResponseError extends Error {
    responseBody: string;
    statusCode: number;
    url: string;

    constructor(message: string, opts: { responseBody: string; statusCode: number; url: string }) {
        super(message);
        this.name = 'ResponseError';
        this.responseBody = opts.responseBody;
        this.statusCode = opts.statusCode;
        this.url = opts.url;
    }

    static async fromResponse(message: string, response: FetchResponse | Response): Promise<ResponseError> {
        let responseBody = '';

        if ('text' in response) {
            try {
                responseBody = await response.text();
                response.text = async () => responseBody; // This can only be called once per response and we've used it up, so replace it
            } catch {
                // Swallow error
            }
        } else {
            responseBody = response.body;
        }

        const statusCode = 'status' in response ? response.status : response.statusCode;

        const fullMessage = `${message}: ${statusCode} ${responseBody}`;

        return new ResponseError(fullMessage, {
            responseBody,
            statusCode,
            url: response.url,
        });
    }
}
